import { localize } from './formLocales';

const generateURIText = (formData, values, questionsMap, responseNumber) => {
  let text = formData.name ? '*' + formData.name + '*\n' : '';

  // response number
  if (responseNumber) {
    text +=
      `*${localize[formData?.language || 'en'].response}* #` +
      responseNumber +
      '\n';
  }

  let currentSection;
  /**
   * @type {Map<string, boolean>} questionSectionToShowMap
   * questionSectionToShowMap is a map that holds the section and their visibility status
   * visibility status is based on whether the questions under the section are answered or not
   */
  const questionSectionToShowMap = new Map();
  Object.keys(questionsMap).forEach(questionId => {
    const question = questionsMap[questionId];
    if (!question || !question.label) return;
    if (question.type === 'SECTION') {
      currentSection = questionId;
      questionSectionToShowMap.set(currentSection, false);
      return;
    }
    if (values[questionId]) questionSectionToShowMap.set(currentSection, true);
  });

  const hasMoreThanOneSection = questionSectionToShowMap.size > 1;
  let sectionOrder = 1;

  Object.keys(questionsMap).map((questionId, index) => {
    if (values[questionId] && questionsMap[questionId].label) {
      switch (questionsMap[questionId].type) {
        case 'FILE': {
          text +=
            '*' +
            questionsMap[questionId].label +
            ' :* ' +
            'https://files.whatsform.com/' +
            values[questionId].answer +
            '\n';
          break;
        }
        default: {
          text +=
            '*' +
            questionsMap[questionId].label +
            ' :* ' +
            values[questionId].answer +
            '\n';
        }
      }
    } else if (values[questionId] && !questionsMap[questionId].label) {
      text +=
        `*${localize[formData?.language || 'en'].question} ${index + 1} :* ` +
        values[questionId].answer +
        '\n';
    }

    if (
      questionsMap[questionId].type === 'HEADER' &&
      questionsMap[questionId].label
    ) {
      text += '\n*' + questionsMap[questionId].label + '*\n\n';
    }

    if (
      questionsMap[questionId].type === 'SECTION' &&
      hasMoreThanOneSection &&
      questionSectionToShowMap.get(questionId)
    ) {
      text +=
        '\n*' +
        (questionsMap[questionId].label ||
          `${localize[formData?.language || 'en'].section} ${sectionOrder}`) +
        '*────────────────\n\n';
      sectionOrder++;
    }

    if (
      questionsMap[questionId].type === 'PAYMENT' &&
      values[questionId].paymentReferenceNo
    ) {
      text +=
        '*' +
        `${localize[formData?.language || 'en'].referenceNo} :* ` +
        values[questionId].paymentReferenceNo +
        '\n';
    }
  });

  return text;
};

export default generateURIText;
